/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["mn.", "h.", "mrg.", "sd.", "kv.", "n."], ["miðnætti", "hádegi", "að morgni", "síðdegis", "að kvöldi", "að nóttu"], u], [["mn.", "hd.", "mrg.", "sd.", "kv.", "n."], ["miðnætti", "hádegi", "morgunn", "síðdegis", "kvöld", "nótt"], ["miðnætti", "hádegi", "morgunn", "eftir hádegi", "kvöld", "nótt"]], ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "06:00"]]];
